<template>
    <div id="app" class="hero is-fullheight">
        <div class="hero-body has-text-centered scrolling">
            <div class="container overflow" :class="{'is-top': isTop}">
                <!--
                <loading :active.sync="isLoading"></loading>
                -->
                <router-view></router-view>
            </div>
        </div>
    </div>
</template>
<script>
    // Import component
    import Loading from 'vue-loading-overlay';
    // Import stylesheet
    import 'vue-loading-overlay/dist/vue-loading.min.css';

    export default {
        name: 'app',
        data() {
            return {
                isTop: false,
                isLoading: false,
            }
        },
        mounted() {
            this.isLoading = this.$parent.isLoading;
        },
        components: {
            Loading
        }
    }
</script>
<style>
    .container {
        margin-right: auto;
        margin-left: auto;
        padding-left: 15px;
        padding-right: 15px;
    }
        @media (min-width: 1200px){
        .container {
            width: 1170px;
            max-width: unset;
        }
    }
    .container.overflow {
        overflow: auto;
    }
    .scrolling{
        /* height: 924px; */
        /* overflow: scroll; */
        /* overflow-x: hidden; */
        /* overflow-y:hidden; */
    }

    html{
        overflow-y: auto;
    }

    .is-top{
        align-self: flex-start;
    }

    .grab-bing {
        cursor : -webkit-grab;
        cursor : -moz-grab;
        cursor : -o-grab;
        cursor : grab;
    }


    .grab-bing:active {
        cursor : -webkit-grabbing;
        cursor : -moz-grabbing;
        cursor : -o-grabbing;
        cursor : grabbing;
    }
</style>



// WEBPACK FOOTER //
// App.vue?4dca9770